<template>
  <div class="c-navbar" v-if="show">
    <div class="left" @click="goBack">
      <div class="back-icon"></div>
      <div>返回</div>
    </div>
    <div class="center">
      {{ title }}
    </div>
    <div class="right">
      <slot name="right">
        <template v-if="showAboutMe">
          <span @click="openAboutMe" class="user-center"></span>
        </template>
        <template v-if="share">
          <span @click="shareClick" class="share"></span>
        </template>
      </slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import device from '../../tools/device'

  export default {
    name: 'c-navbar',
    props: {
      title: {
        type: String,
        default: '生意商城'
      },
      right: {
        type: Boolean,
        default: true
      },
      share: {
        type: Object,
        default: null
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {
      if (device.ios) {
      //  ios设置navbar
        if (!window.$fe_bridge) return
        $fe_bridge.navigation.setTitle(this.title) // eslint-disable-line
      }
    },
    beforeDestroy () {},
    methods: {
      goBack () {
        let nowPath = this.$route.path
        let haveRedirect = location.search.length !== 0
        if (nowPath === '/' || haveRedirect || nowPath === '/dealer') {
          $fe_bridge.navigation.popViewController() // eslint-disable-line
          return
        }
        this.$router.back()
      },
      openAboutMe () {
        this.$router.push({path: `${this.$route.path}aboutMe`})
      },
      shareClick () {
        if ('onClick' in this.share) this.share.onClick()
      }
    },
    computed: {
      show () {
        return device.android
      },
      showAboutMe () {
        let nowPath = this.$route.path
        return nowPath === '/'
      }
    },
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?b2f3e376